import * as React from 'react';
import { useStyles } from '@sravni/react-utils';
import { Space } from '../../Space/src/Space.js';
import modules_6b210db9 from '../styles/Menu.module.less.js';

/**
 * @description The Menu component shows a list of actions that user can take
 *
 * @component
 * @example
 * ```jsx
 * <Menu>
 *   <Menu.Item>1 год</Menu.Item>
 *   <Menu.Item>2 года</Menu.Item>
 * </Menu>
 * ```
 */
const Menu = React.forwardRef((props, ref) => {
    const { className, children, ...restProps } = props;
    const cx = useStyles(modules_6b210db9);
    const classNames = cx(className, 'container');
    return (React.createElement(Space, { ref: ref, "data-qa": "Menu", direction: "vertical", size: 0, className: classNames, ...restProps }, children));
});
Menu.defaultProps = {};
Menu.displayName = 'Menu';

export { Menu };
//# sourceMappingURL=Menu.js.map
